var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ fontFamily: "Lato", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 24" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", stroke: "#979797", strokeWidth: "1.5" },
      React.createElement("path", { d: "M13.04.75H1.5a.75.75 0 0 0-.75.75v21c0 .41.34.75.75.75h17a.75.75 0 0 0 .75-.75V7.53L13.04.75z" }),
      React.createElement("path", { strokeLinecap: "square", d: "M5.08 12.75h9m-9 3h9m-9 3h9" }),
      React.createElement("path", { fill: "#FFF", d: "M12.67 1.22v6.34a.3.3 0 0 0 .3.3h5.9a.3.3 0 0 0 .22-.5l-5.9-6.34a.3.3 0 0 0-.52.2z" })
    )
  );
});